import axios from 'axios'
import { useContext, useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import urlSearchParams from '../../components/urlSearchParams'
import { UserContext } from '../../context api/UserContext'
import { bulkUploadPopup, toastMessage } from '../../shared/AlertPopup'
import { API } from '../../shared/API'
import { error, getNewToken, ROUTES, success } from '../../shared/constants'
import { formTokenHeader } from '../HeaderHelper'

export const useRestApi = (setLoading, message, redirect, getUrl) => {
  const user = useContext(UserContext)
  const token = user && user.token
  const header = formTokenHeader(token)
  const history = useHistory()
  const [cancelToken, setCancelToken] = useState()

  useEffect(() => {
    if (cancelToken) {
      setLoading(true)
    }
  }, [cancelToken])

  const ADD = (url, dto, bulkUpload, newData = () => {}) => {
    setLoading(true)
    axios
      .post(API[url], dto, header)
      .then(({ status, data }) => {
        setLoading(false)

        if (status !== 201) {
          return toastMessage('Something Went Wrong !', error)
        }
        newData(data.data);
        if (bulkUpload) {
          bulkUploadPopup(data, newData)
          setInterval(() => {
            window.location.reload()
          }, 1000)
        } else {
          toastMessage(`${message}  Added Successfully`, success)
          history.push(ROUTES[redirect])
        }
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error || (err.response.data.errors.length && err.response.data.errors[0].msg), error)
        }
      })
  }

  const GET_ALL = (url, setPaginate = () => {}, getData = () => {}, dto = {}) => {
    setLoading(true)
    axios
      .get(API[url](urlSearchParams(dto)), {
        ...header,
        cancelToken: getNewToken(cancelToken, setCancelToken),
      })
      .then(({ status, data }) => {
        console.log({ CHeCK: data.data })
        setLoading(false)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }
        setPaginate(data.paginate)
        getData(data.data)
      })
      .catch((err) => {
        //console.log('err : ', err)
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error || (err.response.data.errors.length && err.response.data.errors[0].msg), error)
        }
      })
  }

  const UPDATE = (url, dto = {}) => {
    setLoading(true)
    axios
      .put(API[url](dto._id), dto, header)
      .then(({ status, data }) => {
        setLoading(false)

        if (status !== 201) {
          return toastMessage('Something Went Wrong !', error)
        }
        toastMessage(`${message} Updated Successfully`, success)
        history.push(ROUTES[redirect])
        GET_ALL(getUrl)
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error || (err.response.data.errors.length && err.response.data.errors[0].msg), error)
        }
      })
  }

  const GET_SINGLE = (url, setData = () => {}, id) => {
    setLoading(true)
    axios
      .get(API[url](id), header)
      .then(({ status, data }) => {
        setLoading(false)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }

        setData(data.data)
      })
      .catch((err) => {
        //console.log(err)
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error || (err.response.data.errors.length && err.response.data.errors[0].msg), error)
        }
      })
  }

  const GET_SINGLE_DATA = (url, setData = () => {}, id) => {
    console.log({ id })
    setLoading(true)
    axios
      .get(API[url](id), header)
      .then(({ status, data }) => {
        setLoading(false)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }

        setData(Array.isArray(data.data) ? data.data[0] : data.data)
      })
      .catch((err) => {
        //console.log(err)
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error || (err.response.data.errors.length && err.response.data.errors[0].msg), error)
        }
      })
  }

  const GET_ALL_DATA = async (dto, url, setFormData, formData) => {
    setFormData({ ...formData, loading: true })
    axios
      .get(API[url](urlSearchParams(dto)), {
        ...header,
        // cancelToken: getNewToken(cancelToken, setCancelToken),
      })
      .then(({ status, data }) => {
        setFormData({ ...formData, loading: false })

        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }
        // setPaginate(data.paginate)
        setFormData({ ...formData, allData: data.data })
      })
      .catch((err) => {
        //console.log('err : ', err)
        setFormData({ ...formData, loading: false })

        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error || (err.response.data.errors.length && err.response.data.errors[0].msg), error)
        }
      })
  }
  // const GET_SINGLE_DATA = (url, setData = () => {}, id) => {
  //   setLoading(true)
  //   axios
  //     .get(API[url](urlSearchParams(id)), header)
  //     .then(({ status, data }) => {
  //       setLoading(false)
  //       if (status !== 200) {
  //         return toastMessage('Something Went Wrong !', error)
  //       }

  //       setData(Array.isArray(data.data) ? data.data[0] : data.data)
  //     })
  //     .catch((err) => {
  //       //console.log(err)
  //       setLoading(false)
  //       if (err.response) {
  //         //console.log(err.response)
  //         return toastMessage(err.response.data.error || (err.response.data.errors.length && err.response.data.errors[0].msg), error)
  //       }
  //     })
  // }

  const DELETE = (url, dto, id, setSelected = () => {}, refreshData = () => {}) => {
    console.log({ dto, url, id })
    setLoading(true)
    axios
      .delete(API[url](urlSearchParams(dto)), header)
      .then(({ status, data }) => {
        setLoading(false)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }
        toastMessage(`${dto[id].length} ${message} Deleted Successfully`, success)
        dto[id].map((item) => refreshData(item))
        // GET_ALL(getUrl)
        setSelected([])
        window.location.reload()
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error || (err.response.data.errors.length && err.response.data.errors[0].msg), error)
        }
      })
  }

  return { ADD, GET_ALL, UPDATE, GET_SINGLE, DELETE, GET_SINGLE_DATA, GET_ALL_DATA }
}
